<template>
  <div class="modal fade emailModal" id="" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog  modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <form method="POST">
          <div class="modal-body">
            <div class="row row-data">
              <div class="col-12 pro-style">Neues Projekt anlegen</div>
              <div class="col-lg-5 col-md-5 col-sm-5 col-2nd">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label class="form-label">Projektname *</label>
                    <div class="input-group">
                      <input class="input--style-2" type="text" placeholder="Neubau Musterhausen" name="name">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 mb-1">
                    <input class="radio-side" type="radio" name="status" value="Aktiviert">
                    <label for="Aktiviert" class="side-lable">Aktiviert</label>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 mb-1">
                    <input class="radio-side" type="radio" name="status" value="Aktiviert1">
                    <label for="Aktiviert1" class="side-lable">Aktiviert1</label>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-3rd">
                <div class="row">
                  <div class="custom-control custom-checkbox mb-3 custom-check">
                    <input type="checkbox" class="custom-control-input" id="customCheck4" name="example4">
                    <label class="custom-control-label lb-dn form-label" for="customCheck4">Als Test- / Demoprojekt anlegen</label>
                  </div>
                </div>
                <div class="form-group">
                  <select  class="cus-select1" size="6">
                    <option value="volvo">Volvo</option>
                    <option value="saab">Saab</option>
                    <option value="fiat">Fiat</option>
                    <option value="audi">Audi</option>
                  </select>
                </div>
                <div class="row">
                  <div class="custom-control custom-checkbox mb-3 custom-check">
                    <input type="checkbox" class="custom-control-input" id="customCheck2" name="example2">
                    <label class="custom-control-label lb-dn form-label" for="customCheck2">Als Test- / Demoprojekt anlegen</label>
                  </div>
                </div>
                <textarea class="w-100"></textarea>
              </div>
            </div>
            <div class="modal-photo-sec row-data overflow row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="form-label">Projektname *</label>
                <div class="input-group">
                  <textarea class="w-100"></textarea>
                </div>
              </div>
              <div class="col-lg-11 col-md-11 col-sm-11">
                <h6 class="border-bottom py-2 mb-3">Demoprojekt anlegen</h6>
                <ul class=" img-thumb-list"  v-for="img in selectedPhots">
                  <li><img height="40" width="40" class="rounded" :src="img.src" alt="img1"></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer mf-1st">
            <button type="button" class="btn mode-d btn-red" data-dismiss="modal">Abbrechen</button>
            <button type="button" class="btn btn-primary mode-s" >Projekt anlegen
            </button>
            <div class="cross-close" data-dismiss="modal"><img src="@/assets/images/cross.png"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'EmailModal',
  props: ['selectedPhots'],
  components: {

  },
  mounted () {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/photo/components/EmailModal.vue